module.exports = __webpack_public_path__ + "img/img_7.2ae9a6ec.png";